$(document).on("click", "a.google_auth_link_click", function (e) {
  e.stopImmediatePropagation();
  e.preventDefault();

  const link = $(this);

  const { href } = link[0];
  const method = link.data("method");
  const target = link.attr("target");
  const csrfToken = $("meta[name=csrf-token]").attr("content");
  const csrfParam = $("meta[name=csrf-param]").attr("content");
  const form = $(`<form method="post" action="${href}"></form>`);
  let metadataInput = `<input name="_method" value="${method}" type="hidden" />`;

  if (csrfParam !== undefined && csrfToken !== undefined) {
    metadataInput += `<input name="${csrfParam}" value="${csrfToken}" type="hidden" />`;
  }

  if (target) {
    form.attr("target", target);
  }

  form.hide().append(metadataInput).appendTo("body");
  form.submit();
});
